import { render } from "./NexusMain.vue?vue&type=template&id=1a08759a"
import script from "./NexusMain.vue?vue&type=script&lang=js"
export * from "./NexusMain.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__